import React from "react";
import ReactDOM from "react-dom/client";
import 'react-quill/dist/quill.snow.css';
import "jsvectormap/dist/css/jsvectormap.css";
import 'react-toastify/dist/ReactToastify.css';
import 'react-modal-video/css/modal-video.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'daterangepicker/daterangepicker.css';
import $ from 'jquery';
import 'daterangepicker/daterangepicker.js';
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { FilterProvider } from "./utils/FilterContext";
import { FullscreenProvider } from "./utils/FullscreenContext";
import { Provider } from "react-redux";
import store from "./utils/redux/store";
import FilterInitializer from "./utils/FilterInitializer";
import { BrowserRouter } from "react-router-dom";



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <Provider store={store}>
      <FilterProvider>
        {/* <FilterInitializer> */}
        <FullscreenProvider>
          <App />
        </FullscreenProvider>
        {/* </FilterInitializer> */}
      </FilterProvider>
    </Provider>
  </>
);

reportWebVitals();
